import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ShieldAlert, CheckCircle2, Loader2 } from 'lucide-react';
import { api, errorMessage } from '../lib/api';
import { Button } from '../components/ui/button';
import { BrandMark } from '../components/BrandMark';

export default function Lockdown() {
  const [search] = useSearchParams();
  const token = search.get('token') || '';
  const [state, setState] = useState({ busy: true });
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    if (!token) { setState({ busy: false, error: 'This link is missing its token.' }); return; }
    api.post('/auth/lockdown', { token }).then(({ data }) => { localStorage.removeItem('kyc_token'); localStorage.removeItem('kyc_session'); setState({ busy: false, ok: true, ...data }); }).catch((e) => setState({ busy: false, error: errorMessage(e) }));
  }, [token]);
  return (
    <div className="min-h-screen bg-paper-100 py-10 px-4">
      <div className="max-w-md mx-auto mb-8"><BrandMark /></div>
      <div className="max-w-md mx-auto rounded-2xl border border-line bg-white shadow-card p-8" data-testid="lockdown-card">
        {state.busy ? <div className="flex items-center gap-2 text-sm text-ink-500" data-testid="lockdown-busy"><Loader2 className="h-4 w-4 animate-spin" />Locking your account…</div> : state.ok ? (
          <>
            <div className="h-12 w-12 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-700 flex items-center justify-center"><CheckCircle2 className="h-6 w-6" /></div>
            <h1 className="mt-4 text-xl font-semibold text-ink-800" data-testid="lockdown-ok">Your account is locked down</h1>
            <p className="mt-2 text-sm text-ink-600">Every session for <span className="font-medium">{state.email}</span> has been signed out, all known browsers were forgotten and a new password is now required.</p>
            <p className="mt-3 text-sm text-ink-600" data-testid="lockdown-next">{state.resetEmailed ? 'We emailed you a password-reset link (valid for 1 hour). Use it to choose a new password before signing in again.' : 'Email is not configured on this instance, so ask an administrator to reset your password (they can do it from Settings → Users or the server console).'}</p>
            <p className="mt-3 text-xs text-ink-400">Your administrators have been notified so the suspicious sign-in can be reviewed.</p>
            <div className="mt-6 flex gap-2"><Button asChild variant="outline"><Link to="/login">Back to sign in</Link></Button></div>
          </>
        ) : (
          <>
            <div className="h-12 w-12 rounded-xl bg-rose-50 border border-rose-200 text-rose-700 flex items-center justify-center"><ShieldAlert className="h-6 w-6" /></div>
            <h1 className="mt-4 text-xl font-semibold text-ink-800">This link cannot be used</h1>
            <p className="mt-2 text-sm text-ink-600" data-testid="lockdown-error">{state.error}</p>
            <div className="mt-6 flex gap-2"><Button asChild variant="outline"><Link to="/login">Back to sign in</Link></Button></div>
          </>
        )}
      </div>
    </div>
  );
}
